/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Notintro1Inputs */

const id_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penting untuk menjelaskan bahwa egdata.app bukan:`)
};

const ms_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adalah penting untuk menjelaskan bahawa egdata.app bukan:`)
};

const da_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det er vigtigt at præcisere at egdata.app ikke er:`)
};

const de_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist wichtig klarzustellen, dass egdata.app nicht ist:`)
};

const en_us2_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's important to clarify that egdata.app is not:`)
};

const es_es2_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es importante aclarar que egdata.app no es:`)
};

const es_mx2_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es importante aclarar que egdata.app no es:`)
};

const fil_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahalagang linawin na ang egdata.app ay hindi:`)
};

const fr_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il est important de préciser qu'egdata.app n'est pas :`)
};

const it_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È importante chiarire che egdata.app non è:`)
};

const hu_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontos tisztázni, hogy az egdata.app nem:`)
};

const nl_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is belangrijk om te verduidelijken dat egdata.app niet is:`)
};

const no_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det er viktig å presisere at egdata.app ikke er:`)
};

const pl_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ważne jest, aby wyjaśnić, że egdata.app nie jest:`)
};

const pt_br2_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É importante esclarecer que egdata.app não é:`)
};

const pt_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É importante esclarecer que o egdata.app não é:`)
};

const ro_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este important să clarificăm că egdata.app nu este:`)
};

const fi_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On tärkeää selventää, että egdata.app ei ole:`)
};

const sv_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det är viktigt att klargöra att egdata.app inte är:`)
};

const vi_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều quan trọng cần làm rõ rằng egdata.app không phải là:`)
};

const tr_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app'in şunlar olmadığını açıklığa kavuşturmak önemlidir:`)
};

const cs_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je důležité objasnit, že egdata.app není:`)
};

const bg_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Важно е да се изясни, че egdata.app не е:`)
};

const ru_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Важно прояснить, что egdata.app не является:`)
};

const uk_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Важливо зазначити, що egdata.app не є:`)
};

const ar_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من المهم توضيح أن egdata.app ليس:`)
};

const hi_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह स्पष्ट करना महत्वपूर्ण है कि egdata.app नहीं है:`)
};

const th_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งสำคัญที่ต้องชี้แจงคือ egdata.app ไม่ใช่:`)
};

const ja_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app は以下ではないことを明確にすることが重要です：`)
};

const zh_cn2_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要明确的是，egdata.app 不是：`)
};

const zh_hant1_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要明確的是，egdata.app 不是：`)
};

const ko_privacy_notintro1 = /** @type {(inputs: Privacy_Notintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app은 다음과 같지 않음을 분명히 합니다:`)
};

/**
* | output |
* | --- |
* | "It's important to clarify that egdata.app is not:" |
*
* @param {Privacy_Notintro1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_notintro1 = /** @type {((inputs?: Privacy_Notintro1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Notintro1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_notintro1(inputs)
	if (locale === "ms") return ms_privacy_notintro1(inputs)
	if (locale === "da") return da_privacy_notintro1(inputs)
	if (locale === "de") return de_privacy_notintro1(inputs)
	if (locale === "en-US") return en_us2_privacy_notintro1(inputs)
	if (locale === "es-ES") return es_es2_privacy_notintro1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_notintro1(inputs)
	if (locale === "fil") return fil_privacy_notintro1(inputs)
	if (locale === "fr") return fr_privacy_notintro1(inputs)
	if (locale === "it") return it_privacy_notintro1(inputs)
	if (locale === "hu") return hu_privacy_notintro1(inputs)
	if (locale === "nl") return nl_privacy_notintro1(inputs)
	if (locale === "no") return no_privacy_notintro1(inputs)
	if (locale === "pl") return pl_privacy_notintro1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_notintro1(inputs)
	if (locale === "pt") return pt_privacy_notintro1(inputs)
	if (locale === "ro") return ro_privacy_notintro1(inputs)
	if (locale === "fi") return fi_privacy_notintro1(inputs)
	if (locale === "sv") return sv_privacy_notintro1(inputs)
	if (locale === "vi") return vi_privacy_notintro1(inputs)
	if (locale === "tr") return tr_privacy_notintro1(inputs)
	if (locale === "cs") return cs_privacy_notintro1(inputs)
	if (locale === "bg") return bg_privacy_notintro1(inputs)
	if (locale === "ru") return ru_privacy_notintro1(inputs)
	if (locale === "uk") return uk_privacy_notintro1(inputs)
	if (locale === "ar") return ar_privacy_notintro1(inputs)
	if (locale === "hi") return hi_privacy_notintro1(inputs)
	if (locale === "th") return th_privacy_notintro1(inputs)
	if (locale === "ja") return ja_privacy_notintro1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_notintro1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_notintro1(inputs)
	return ko_privacy_notintro1(inputs)
});
export { privacy_notintro1 as "privacy.notIntro" }